import { render, staticRenderFns } from "./FiltrarConcursos.vue?vue&type=template&id=140f475c"
import script from "./FiltrarConcursos.vue?vue&type=script&lang=ts"
export * from "./FiltrarConcursos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports